var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),title = locals_.title,subtitle = locals_.subtitle;
var jade_indent = [];
buf.push("\n<div style=\"margin-bottom: 0\" class=\"navbar navbar-inverse\">\n  <div class=\"nav-header\">\n    <button type=\"button\" data-toggle=\"collapse\" data-target=\".sidebar-collapse\" class=\"navbar-toggle\"><span class=\"sr-only\">Toggle navigation</span><span class=\"icon-bar\"></span><span class=\"icon-bar\"></span><span class=\"icon-bar\"></span></button><a href=\"#/\" class=\"navbar-brand\">" + (jade.escape((jade_interp = title) == null ? '' : jade_interp)) + "<sup>ALPHA</sup>");
if (subtitle)
{
buf.push("<span> for " + (jade.escape((jade_interp = subtitle) == null ? '' : jade_interp)) + "</span>");
}
buf.push("</a>\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}